<template>
  <div class="heads">
    <p class="title" v-if="imgInfo && imgInfo.length > 0">{{ $t("case.p6") }}</p>
    <swiper class="gallery-thumbs swiper2" :options="swiperOptionThumbs" ref="swiperThumbs"
      v-if="imgInfo && imgInfo.length > 0">
      <swiper-slide v-for="(item, index) in imgInfo" :key="index" class="w-20">
        <img :src="item.cover_img" @click="open(item.id)" style="height: auto;" />
        <p class="item-title">{{ item.title }}</p>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
var vm = null
export default {
  name: "swiper-example-thumbs-gallery",
  title: "Thumbs gallery with Two-way control",
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    swidth: {
      type: Number
    }
  },
  data() {
    return {
      imgInfo: [], //图片列表
      swiperOptionThumbs: {
        loop: true,
        spaceBetween: 10,
        slidesPerView: 5,
        touchRatio: 0.2,
        slideToClickedSlide: true,
        initialSlide: 2,
        on: {
          click: function (s, q) {
            if (vm.imgInfo[this.realIndex].id == vm.$route.query.id) {
              return false;
            }
            vm.$router.push(`/industryPavilionCaseDetail?id=${vm.imgInfo[this.realIndex].id}`);
          }
        }
      },
    };
  },
  mounted() {
    this.init();
    vm = this
  },
  methods: {
    init() {
      this.$http.get("/api/cases/latestList").then((res) => {
        if (res.code == 200) {
          this.imgInfo = res.data
          if (this.imgInfo.length < 5) {
            this.swiperOptionThumbs.loop = false
          }
        }
      });
    },
    open(id) {
      // debugger
      // if (id == this.$route.query.id) {
      //   return false;
      // }
      // this.$router.push(`/industryPavilionCaseDetail?id=${id}`);
    },
  },
};
</script>
<style lang="less" scoped>
.heads {
  width: 100%;
  margin-bottom: 20px;
  padding: 0 10px;

  .title {
    font-family: SourceHanSansCN-Regular;
    font-size: 24px;
    color: #666666;
    padding: 40px 0 10px;
    margin: 0;
  }

  .item-title {
    display: -webkit-box;
    /* 设置为WebKit内核的弹性盒子模型 */
    -webkit-box-orient: vertical;
    /* 垂直排列 */
    -webkit-line-clamp: 2;
    /* 限制显示两行 */
    overflow: hidden;
    /* 隐藏超出范围的内容 */
    text-overflow: ellipsis;
    /* 使用省略号 */
  }
}


.swiper-slide img {
  width: 100%;
  object-fit: cover;
}

.gallery-top .swiper-slide {
  width: 100%;
}

.gallery-thumbs .swiper-slide {
  // width: 372px;
  text-align: center;
}

.gallery-thumbs .swiper-slide.swiper-slide-active {
  opacity: 1;
}

.swiper-wrapper {
  width: 100% !important;
}

.small-pic {
  width: 100%;
}

.swiper-btn {
  width: 100%;
}

.small-pic {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/caseDetails/components/Sapar2.vue